import { Routes } from '@angular/router';
import { CorretorExisteGuard } from './guards/corretor-existe.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'anuncie',
    loadComponent: () =>
      import('./anuncie/anuncie.component').then(m => m.AnuncieComponent),
  },
  {
    path: 'busca-avancada',
    loadComponent: () =>
      import('./imoveis/busca.component').then(m => m.BuscaComponent),
  },
  {
    path: 'condominio/:idC',
    loadComponent: () =>
      import('./imoveis/detalhes-condominio/detalhes-condominio.component').then(
        m => m.DetalhesCondominioComponent,
      ),
  },
  {
    path: 'corretor/:idC',
    loadComponent: () =>
      import('./imoveis/busca.component').then(m => m.BuscaComponent),
    canActivate: [CorretorExisteGuard],
  },
  {
    path: 'contato',
    loadComponent: () =>
      import('./contato/contato.component').then(m => m.ContatoComponent),
  },
  {
    path: 'imovel/:id',
    loadComponent: () =>
      import('./imoveis/detalhes-imovel/detalhes-imovel.component').then(
        m => m.DetalhesImovelComponent,
      ),
  },
  {
    path: 'sobre',
    loadComponent: () =>
      import('./sobre/sobre.component').then(m => m.SobreComponent),
  },
  {
    path: 'trabalhe-conosco',
    loadComponent: () =>
      import('./trabalhe-conosco/trabalhe-conosco.component').then(
        m => m.TrabalheConoscoComponent,
      ),
  },
  {
    path: 'termos',
    loadComponent: () =>
      import('./termos-uso/termos-uso.component').then(
        m => m.TermosUsoComponent,
      ),
  },
];
